<template>
  <v-dialog
    v-model="value.show"
    @input="v => v || closeAction()"
    max-width="500px"
    :persistent="true"
  >
    <v-card>
      <v-card-title>
        <span class="headline">{{
          value.mode === "edit" ? $t("editSparePart") : $t("createSparePart")
        }}</span>
      </v-card-title>
      <v-card-text>
        <v-form ref="editCreateForm">
          <v-autocomplete
            name="vehicle"
            :label="$t('vehicle')"
            :loading="vehicleIsLoading"
            :items="vehicles"
            :search-input.sync="vehicleSearch"
            v-model="sparePart.vehicle"
            cache-items
            prepend-icon="train"
            item-text="name"
            item-value="id"
            v-validate="'required'"
            :data-vv-as="$t('vehicle')"
            :error-messages="errors.collect('vehicle')"
          ></v-autocomplete>
          <v-autocomplete
            name="spare_part_type"
            :label="$t('sparePartType')"
            :loading="sparePartTypeIsLoading"
            :items="sparePartTypes"
            :search-input.sync="sparePartTypeSearch"
            v-model="sparePart.type"
            cache-items
            item-text="name"
            item-value="id"
            v-validate="'required'"
            :data-vv-as="$t('sparePartType')"
            :error-messages="errors.collect('spare_part_type')"
          ></v-autocomplete>
          <v-text-field
            name="serial_number"
            :label="$t('serialNumber')"
            type="text"
            v-model="sparePart.serial_number"
            v-validate="'required|max:255'"
            :data-vv-as="$t('serialNumber')"
            :error-messages="errors.collect('serial_number')"
          ></v-text-field>
        </v-form>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn
          color="blue darken-1"
          flat
          @click.native="closeAction"
          :disabled="value.formDisabled"
          >{{ $t("close") }}</v-btn
        >
        <v-btn
          color="blue darken-1"
          flat
          @click.native="saveAction"
          :disabled="value.formDisabled"
          >{{ $t("save") }}</v-btn
        >
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapGetters } from "vuex";
import {
  UPDATE_SPARE_PART,
  CREATE_SPARE_PART,
  RESET_SPARE_PART,
  SHOW_SNACKBAR,
  FETCH_VEHICLES,
  FETCH_SPARE_PART_TYPES
} from "@/store/actions.type";
import validationErrorsMixin from "@/mixins/validationErrors.mixin";
import _ from "lodash";

export default {
  props: ["value"],
  data() {
    return {
      formDisabled: false,
      vehicleSearch: "",
      sparePartTypeSearch: ""
    };
  },
  computed: {
    ...mapGetters([
      "sparePart",
      "vehicles",
      "vehiclesCount",
      "vehicleIsLoading",
      "sparePartTypes",
      "sparePartTypesCount",
      "sparePartTypeIsLoading"
    ])
  },
  mixins: [validationErrorsMixin],
  watch: {
    vehicleSearch: _.debounce(function(val) {
      this.$store.dispatch(FETCH_VEHICLES, [{ rowsPerPage: -1 }, val]);
    }, 300),
    sparePartTypeSearch: _.debounce(function(val) {
      this.$store.dispatch(FETCH_SPARE_PART_TYPES, [{ rowsPerPage: -1 }, val]);
    }, 300)
  },
  methods: {
    saveAction() {
      this.$validator.validateAll().then(result => {
        if (result) {
          this.formDisabled = true;

          if (_.isObject(this.sparePart.vehicle)) {
            this.sparePart.vehicle = this.sparePart.vehicle.id;
          }
          if (_.isObject(this.sparePart.type)) {
            this.sparePart.type = this.sparePart.type.id;
          }
          this.$store
            .dispatch(
              this.value.mode === "edit"
                ? UPDATE_SPARE_PART
                : CREATE_SPARE_PART,
              this.sparePart
            )
            .then(() => {
              this.$store.dispatch(SHOW_SNACKBAR, {
                text: this.$t("savedSuccessfully", [this.$t("sparePart")]),
                color: "success"
              });

              this.closeAction();
              this.$emit("saved");
            })
            .catch(() => {
              this.formDisabled = false;
            });
        }
      });
    },
    closeAction() {
      this.$emit("input", {
        mode: this.value.mode,
        show: false
      });
      this.formDisabled = false;
      // we need wait for animation until is finished
      setTimeout(() => {
        this.$store.dispatch(RESET_SPARE_PART);
        this.$refs.editCreateForm.reset();
        this.$validator.reset();
      }, 100);
    }
  }
};
</script>

<style scoped></style>
